/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";
import { default as apiConfing } from "../config.json";

const apiUrl = apiConfing.IS_DEVELOPMENT
  ? apiConfing.API_DEVELOPMENT
  : apiConfing.API_PRODUCTION;

const paymentApiEndpoint = `${apiUrl}/Payment`;

// Get payment details from Payment controller
export const getPaymentDetails = (pageRequestUid: string) => {
  const url = `${paymentApiEndpoint}/GetPaymentDetails?pageRequestUid=${pageRequestUid}`;
  return http.get(url);
};

export const cancelRecurringPaymentWeb = (recurringPaymentUid: string) => {
  const url = `${paymentApiEndpoint}/CancelRecurringPaymentWeb`;
  return http.post(url, { recurringPaymentUid });
};

// export const renewRecurringPaymentWeb = (recurringPaymentUid: string) => {
//   const url = `${paymentApiEndpoint}/RenewRecurringPaymentWeb`;
//   return http.post(url, { recurringPaymentUid });
// };

export default {
  getPaymentDetails,
  cancelRecurringPaymentWeb,
};
